import React from 'react';
import { IconProps } from '.';

const SvgBoxZigzagMate = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#000'
        d='M2 5.022A3.016 3.016 0 0 1 5.01 2h13.98A3.016 3.016 0 0 1 22 5.022v13.956A3.016 3.016 0 0 1 18.99 22H5.01A3.016 3.016 0 0 1 2 18.978V5.022Z'
      />
      <path fill='#fff' d='M8.198 6.5v2.57h3.395L8 17.5h7.802v-2.577h-3.37L16 6.5H8.198Z' />
    </svg>
  );
};

export default SvgBoxZigzagMate;
